import React, { FC } from "react";
import { SelectDocumentModal } from "../SelectDocumentModal/SelectDocument";
import { t } from "i18next";
import { Document } from "../../../models";

interface SelectDocumentProps {
  isModalOpen: boolean;
  hideModal: () => void;
  showModal: () => void;
  showShareModal: () => void;
  selectedDocuments: Document[];
  setSelectedDocuments: React.Dispatch<React.SetStateAction<Document[]>>;
}

const SelectDocumentsForSharingModal: FC<SelectDocumentProps> = (props) => {
  const handleEmailPrepare = () => {
    if (props?.selectedDocuments?.length === 0) {
      return;
    } else {
      props?.hideModal();
      props?.showShareModal();
    }
  };

  return (
    <SelectDocumentModal
      isModalOpen={props.isModalOpen}
      hideModal={props.hideModal}
      showModal={props.showModal}
      selectedDocuments={props.selectedDocuments}
      setSelectedDocuments={props.setSelectedDocuments}
      title={String(t("select_documents"))}
      actionButton={{
        text: String(t("prepare_email")),
        onClick: handleEmailPrepare,
        className: "prepareEmailButton"
      }}
    />
  );
};

export default SelectDocumentsForSharingModal;
